import React from 'react';
import { promiseItems } from '../data/content';
import { SectionHeading } from './SectionHeading';
export function CorePromise() {
  return <section aria-labelledby="promesa" className="w-full bg-ink" data-id="element-49" data-mp="3flnkipupgk6l">
      <div className="mx-auto max-w-content px-5 py-10 sm:py-16 lg:py-24" data-id="element-50" data-mp="3anc9wcwl65nb">
        <div className="grid gap-7 lg:grid-cols-[1fr_0.85fr] lg:gap-20" data-id="element-51" data-mp="35paovmflnw97">
          <div data-id="element-52" data-mp="35my0orj90pnp">
            <SectionHeading eyebrow="La transformación" title="La diferencia del Sistema Memorias del Alma™" data-id="element-53" data-mp="77etvnbqu3h2" />
            <p className="mt-6 max-w-xl text-lg leading-relaxed text-cream/85" data-id="element-54" data-mp="28liq1jxiok2">
              De la incertidumbre en el trance a la maestría terapéutica. Dale a tus
              sesiones una estructura profesional e impecable, a tus consultantes una
              experiencia de sanación profunda y a ti la serenidad de saber exactamente
              cómo actuar ante cualquier interferencia.
            </p>
          </div>

          <ul className="flex flex-col justify-center divide-y divide-line border-y border-line" data-id="element-55" data-mp="2czbudbimz6x5">
            {promiseItems.map(item => <li key={item.title} className="py-5" data-id="element-56" data-mp="o8xmebo2gq7m">
                <p className="font-sans text-[15px] font-semibold text-cream" data-id="element-57" data-mp="t7sey5bu5t4x">
                  {item.title}
                </p>
                <p className="mt-1.5 text-[14px] leading-relaxed text-muted" data-id="element-58" data-mp="e96ri8vlg970">
                  {item.detail}
                </p>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}